import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';
import {fadeInUp} from '@/animation/scroll-animation';
import {AnimatedComponent} from '@/components/Ui-components/AnimatedComponent';
import CommonCard from '@/components/Ui-components/home/common-card';
import DisplayImage from '../display-image';
import Link from 'next/link';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

const bodyColorSx = {color: '#000'} as const;

const LatestPlatform = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <Box>
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                    <Typography variant="h1" component="h2" mb={3} fontSize={{xs: 35, sm: 48}} className="font-headers">
                        {heading}
                    </Typography>
                    <Typography variant="subtitle1" component="p" className="remove-link-underline">
                        {subheading ? parse(subheading) : ''}
                    </Typography>
                </Box>
                <Box>
                    <Grid container spacing={3}>
                        {contentData?.map((item: any, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={index + 1}>
                                <AnimatedComponent variants={fadeInUp} delay={index * 0.2} className="height-full">
                                    <CommonCard>
                                        <DisplayImage alt={item.heading} src={item.src} width={60} height={60} />

                                        {item.redirect ? (
                                            <Typography variant="h3" component="h3" mt={2} mb={2}>
                                                <Link href={item.redirect} className="card-redirection-heading font-headers">
                                                    {item.heading}
                                                </Link>
                                            </Typography>
                                        ) : (
                                            <Typography variant="h3" component="h3" mt={2} mb={2}>
                                                {item.heading}
                                            </Typography>
                                        )}

                                        <Typography variant="body1" className="remove-link-underline" sx={bodyColorSx}>
                                            {item.body ? parse(item.body) : ''}
                                        </Typography>
                                        {item.content && (
                                            <Box mt={1}>
                                                {item.content?.map((point: any, subIndex: any) => (
                                                    <Box key={subIndex}>
                                                        <Box display="flex" gap={1} mt={1}>
                                                            <Box mt={0.5}>
                                                                <CheckCircleOutlineOutlinedIcon fontSize="small" />
                                                            </Box>
                                                            <Typography className="font-regular-text" component="p">
                                                                {point ? parse(point) : ''}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </CommonCard>
                                </AnimatedComponent>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </MUIContainer>
        </Box>
    );
};

export default memo(LatestPlatform);
